import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";

const usageData = [
  {
    title: "Premium Statistics Download",
    used: 154,
    total: 200,
  },
  {
    title: "Comprehensive Market Reports Download",
    used: 2,
    total: 10,
  },
  {
    title: "On-demand Reports Credits",
    used: 4,
    total: 15,
  },
];

const PlanOverview = () => {
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);
  const [StatisticsDownload, setStatisticsDownload] = useState(0);
  const [MarketReportsDownload, setMarketReportsDownload] = useState(0);
  const [OnDemandReports, setOnDemandReports] = useState(0);
  console.log(subscriptions, "profile");
  const handleUpdatePlan = () => {
    navigate("/pricing");
  };
  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axiosClient.get(
            `/subscriptions/getSubscriptionsByUser/${userID}`
          );

          setSubscriptions(response.data);
          console.log(
            "Subscriptions on plan overview:",
            response.data[0].usage
          );
          if (
            response.data.length > 0 &&
            response.data[0].status === "Active"
          ) {
            setMarketReportsDownload(
              response.data[0].plan.features.reportDownloads
            );
          }
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      };
      fetchSubscriptions();
    }
  }, [token, userID]);

  return (
    <div className="px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-10">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold font-inter">
        Plan Overview
      </h2>

      <div className="border rounded-xl p-4 sm:p-5 md:p-6 mt-4 sm:mt-5 md:mt-6">
        <div className="overflow-x-auto">
          <table className="w-full font-inter">
            <thead>
              <tr>
                <th className="text-lg sm:text-xl md:text-2xl font-medium text-left px-3 sm:px-4 pb-3 sm:pb-4">
                  Your Current Plan
                </th>
                <th className="text-lg sm:text-xl md:text-2xl font-semibold text-left px-3 sm:px-4 pb-3 sm:pb-4">
                  Starter Plan
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {subscriptions?.map((item, index) => (
                <tr key={index} className="border border-gray-300">
                  <td className="p-3 sm:p-4 text-sm sm:text-base md:text-lg font-medium">
                    {item.title}
                  </td>
                  <td className="p-3 sm:p-4 text-sm sm:text-base md:text-lg font9 border-l">
                    You've used{" "}
                    <strong className="text-black">
                      {item.downloads?.downloadGraphs}
                    </strong>{" "}
                    out of{" "}
                    <strong className="mr-1 text-black">
                      {" "}
                      {item.usage?.downloadGraphs}
                    </strong>
                    {item.usage?.downloadGraphs}
                  </td>
                </tr>
              ))} */}
              {subscriptions?.map((item, index) => (
                <tr key={index} className="border border-gray-300">
                  <td className="p-3 sm:p-4 text-sm sm:text-base md:text-lg font-medium">
                    {item.title}
                  </td>
                  <td className="p-3 sm:p-4 text-sm sm:text-base md:text-lg font9 border-l">
                    {Object.keys(item.downloads || {}).map((key) => (
                      <div key={key}>
                        You've used{" "}
                        <strong className="text-black">
                          {item.downloads?.[key]}
                        </strong>{" "}
                        {key} out of{" "}
                        <strong className="text-black">
                          {item.usage?.[key]}
                        </strong>{" "}
                        {key}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-4 sm:mt-5 md:mt-6 flex justify-center sm:justify-start">
          <button
            className="w-full sm:w-auto px-6 sm:px-8 py-2 sm:py-3 bg-login text-white rounded-lg hover:bg-black font-inter font-medium text-sm sm:text-base transition-colors"
            onClick={handleUpdatePlan}
          >
            Update Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanOverview;
